export function TopicTitle({ title, topicNumber, taskNumber }) {
  return (
    <div class="flex flex-col gap-10px">
      <p class="text#p text-25px mb-20px leading-28px font-600">{taskNumber}</p>
    </div>
  );
}
